import React, { useState } from 'react';
import millify from 'millify';
import {Col, Typography, Select} from 'antd';
import {CheckOutlined, DollarCircleOutlined, ExclamationCircleOutlined, FundOutlined, MoneyCollectOutlined, NumberOutlined, StopOutlined, ThunderboltOutlined, TrophyOutlined, } from '@ant-design/icons';
import HtmlReactParser from 'html-react-parser';
import {useParams} from 'react-router-dom';
import {useGetCryptoDetailQuery, useGetCryptoHistoryQuery} from '../../../services/cryptoAPI';
import Spinner from '../../utils/Spinner';
import CryptoLineChart from '../../containers/Charts/CryptoLineChart';
import "./CryptoDetails.css";
import CryptoNews from './CryptoNews/CryptoNews';

const {Title, Text} = Typography;
const {Option} = Select;

const CryptoDetails = (props) => {
    const {coinid} = useParams()
    const {data, isFetching} = useGetCryptoDetailQuery(coinid);
    const [timePeriod, setTimePeriod] = useState('7d');
    const {data: cryptoHistory , isFetching: isChartFetching} = useGetCryptoHistoryQuery({coinID: coinid, timePeriod: timePeriod});
    const cryptoDetails = data?.data?.coin;

    const time = ['3h', '24h', '7d', '30d', '1y', '3m', '3y', '5y'];
    
    const stats = [
            { title: 'Price to USD', value: `$ ${cryptoDetails?.price && millify(cryptoDetails.price)}`, icon: <DollarCircleOutlined /> },
            { title: 'Rank', value: cryptoDetails?.rank, icon: <NumberOutlined /> },
            { title: '24h Volume', value: `$ ${cryptoDetails?.volume && millify(cryptoDetails.volume)}`, icon: <ThunderboltOutlined /> },
            { title: 'Market Cap', value: `$ ${cryptoDetails?.marketCap && millify(cryptoDetails.marketCap)}`, icon: <DollarCircleOutlined /> },
            { title: 'All-time-high(daily avg.)', value: `$ ${cryptoDetails?.allTimeHigh?.price && millify(cryptoDetails.allTimeHigh.price)}`, icon: <TrophyOutlined /> },
        ];

    const genericStats = [
                { title: 'Number Of Markets', value: cryptoDetails?.numberOfMarkets, icon: <FundOutlined /> },
                { title: 'Number Of Exchanges', value: cryptoDetails?.numberOfExchanges, icon: <MoneyCollectOutlined /> },
                { title: 'Aprroved Supply', value: cryptoDetails?.approvedSupply ? <CheckOutlined /> : <StopOutlined />, icon: <ExclamationCircleOutlined /> },
                { title: 'Total Supply', value: `$ ${cryptoDetails?.totalSupply && millify(cryptoDetails.totalSupply)}`, icon: <ExclamationCircleOutlined /> },
                { title: 'Circulating Supply', value: `$ ${cryptoDetails?.circulatingSupply && millify(cryptoDetails.circulatingSupply)}`, icon: <ExclamationCircleOutlined /> },
    ];
    
    return (
        <>
          {
              isFetching ? (
                  <Spinner />
              ) : 
              (
                <Col className='coin-detail-container my-4 px-2'>
                    <Col className='coin-heading-container'>
                        <Title level={2} className='coin-name'>
                            {cryptoDetails.name}
                        </Title>
                        <p>
                            {cryptoDetails.name} live price in US Dollars,
                            View Value Statistics, Market Cap and Supply
                        </p>
                    </Col>
                    <Select 
                     defaultValue='7d'
                     onChange={(value) => setTimePeriod(value)}
                     placeholder='Select time period'
                     className='select-timeperiod mx-2'
                    >
                        {
                            time.map((time, i) => (
                                <Option value={time} key={i}>{time}</Option>
                            ))
                        }
                    </Select>
                    {
                            !isChartFetching ? (
                            <CryptoLineChart  cryptoHistory={cryptoHistory} 
                                        coinName={cryptoDetails.name} 
                                        currentPrice={millify(cryptoDetails.price)} />
                        ) : (
                            <div>
                                <Spinner />
                            </div>
                        )
                    }
                    <div className='details-container mx-2 my-4'>
                       <div className='details-container-left'>
                            <div className='details-heading'>
                                <Title level={4}>
                                    {cryptoDetails.name} Value Statistics
                                </Title>
                                <p>
                                    An overview of {cryptoDetails.name}
                                </p>
                            </div>  
                            <div className='details-stats-container'>
                                {stats?.map((stat, i) => (
                                    <div className='details-stats-box' key={i}>
                                        <div>
                                            <Text>
                                                {stat.icon}
                                            </Text>
                                            &nbsp;&nbsp;&nbsp;
                                            <Text>
                                                {stat.title}
                                            </Text>
                                        </div>
                                        <Text style={{flexBasis: "20%"}}>
                                        <strong> {stat.value} </strong>
                                        </Text>
                                    </div>
                                ))}
                            </div>
                       </div>
                       <div className='details-container-right'>
                        <div className='details-heading'>
                                    <Title level={4}>
                                        Other Coins Statistics
                                    </Title>
                                    <p>
                                        An overview of Peers
                                    </p>
                                </div>  
                                <div className='details-stats-container'>
                                    {genericStats?.map((stat, i) => (
                                        <div className='details-stats-box' key={i}>
                                            <div>
                                                <Text>
                                                    {stat.icon}
                                                </Text>
                                                &nbsp;&nbsp;&nbsp;
                                                <Text>
                                                    {stat.title}
                                                </Text>
                                            </div>
                                            <Text style={{flexBasis: "20%"}}>
                                            <strong> {stat.value} </strong>
                                            </Text>
                                        </div>
                                    ))}
                                </div>
                        </div>
                    </div>
                    <br/>
                    <hr style={{opacity: "0.6"}}/>
                    <div className='crypto-description mx-2 my-4'>
                        <Title level={3}>
                            What is {cryptoDetails.name} ?
                        </Title>
                        {HtmlReactParser(cryptoDetails.description)}
                    </div>
                    <br/>
                    <hr/>
                    <br/>
                    <div className="w-100 mx-2 my-4">
                            <Title level={3}>Crypto News</Title>
                            <CryptoNews crypto={cryptoDetails.name}/>
                    </div>
                    <br/>
                    <hr/>
                    <br/>
                    <div className='crypto-details-link mx-2 my-4'>
                        <Title level={3}>
                            {cryptoDetails.name} Links
                        </Title>
                        <div className='crypto-links-container'>
                            {
                                cryptoDetails?.links?.map((link, i) => (
                                    <a href={link.url} target="_blank"  className={`crypto-link-box`} rel="noopener noreferrer" key={i}>
                                        <div id={`color${i}`}>
                                            <h3>{link.type}</h3>
                                            <h4>{link.name}</h4>
                                        </div>
                                    </a>
                                ))
                            }
                        </div>
                    </div>
                </Col>
              )
          }  
        </>
    )
}

export default CryptoDetails
